import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';
import axios from 'axios';

export const sendCustomerPolicyCommunication = async (
    policyNumber: string
): Promise<Boolean> => {
    try {
        const { status } = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/${policyNumber}/send-communication`,
            ...getAxiosConfig(),
        });

        if (status === 200) {
            return true;
        }

        return false;
    } catch (e) {
        return false;
    }
};

export const cancelOrderApi = async (
    partnerId: string,
    orderEkey: string
): Promise<Boolean> => {
    try {
        const { status } = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/order/${orderEkey}/cancel`,
            ...getAxiosConfig(),
        });

        if (status === 200) {
            return true;
        }

        return false;
    } catch (e) {
        return false;
    }
};
